import styled from 'styled-components/macro';

export const Container = styled.div`
  position: relative;
  background-color: #000;
  min-height: 100vh;
  color: #fff;
`;

export const Banner = styled.div`
  position: relative;
  height: 500px;
  background-image: url(${({ src }) => src});
  background-size: cover;
  background-position: center;

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 200px;
    background: linear-gradient(to top, #000, transparent);
  }
`;

export const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
`;

export const Header = styled.div`
  margin-bottom: 30px;
`;

export const Title = styled.h1`
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 15px;
`;

export const SubTitle = styled.h2`
  font-size: 18px;
  color: #999;
  font-weight: normal;
  margin-bottom: 20px;
`;

export const MetaInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
  flex-wrap: wrap;
`;

export const MetaItem = styled.span`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  color: #999;

  &.rating {
    color: #ffa500;
    font-weight: bold;
  }
  &.year,
  &.duration,
  &.country {
    &::before {
      content: '•';
      margin-right: 5px;
    }
  }
`;

export const Tags = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;
`;

export const Tag = styled.span`
  padding: 5px 15px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  font-size: 14px;
  color: #fff;
`;

export const Description = styled.p`
  font-size: 16px;
  line-height: 1.6;
  color: #ccc;
  margin-bottom: 30px;
`;

export const Section = styled.div`
  margin-bottom: 50px;
`;

export const SectionTitle = styled.h2`
  font-size: 24px;
  margin-bottom: 20px;
  font-weight: bold;
`;

export const EpisodeList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
`;

export const Episode = styled.div`
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

export const EpisodeImage = styled.img`
  width: 100%;
  height: 120px;
  object-fit: cover;
`;

export const EpisodeInfo = styled.div`
  padding: 15px;
`;

export const EpisodeTitle = styled.h3`
  font-size: 14px;
  margin-bottom: 5px;
  font-weight: bold;
`;

export const EpisodeDuration = styled.p`
  font-size: 12px;
  color: #999;
`;

export const RelatedVideos = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
`;

export const VideoCard = styled.div`
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

export const VideoImage = styled.img`
  width: 100%;
  height: 120px;
  object-fit: cover;
`;

export const VideoInfo = styled.div`
  padding: 15px;
`;

export const VideoTitle = styled.h3`
  font-size: 14px;
  margin-bottom: 5px;
  font-weight: bold;
`;

export const VideoMeta = styled.p`
  font-size: 12px;
  color: #999;
`;

export const RecommendedFilms = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 20px;
`;

export const FilmCard = styled.div`
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

export const FilmPoster = styled.img`
  width: 100%;
  height: 250px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 10px;
`;

export const FilmPosterHighlight = styled.img`
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 10px;
`;

export const FilmTitle = styled.h3`
  font-size: 14px;
  margin-bottom: 5px;
  font-weight: bold;
`;

export const FilmMeta = styled.p`
  font-size: 12px;
  color: #999;
`;

export const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: white;
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  margin-bottom: 30px;

  svg {
    width: 20px;
    height: 20px;
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.4);
    transform: translateX(-4px);
  }
`;

export const CommentSection = styled.div`
  margin-top: 50px;
`;

export const CommentInput = styled.textarea`
  width: 100%;
  min-height: 100px;
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
  padding: 15px;
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 10px;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: rgba(255, 255, 255, 0.3);
  }
`;

export const CommentButton = styled.button`
  background-color: #0ad519;
  border: none;
  color: white;
  padding: 10px 30px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #0bec1c;
  }
`;

export const CommentList = styled.div`
  margin-top: 30px;
`;

export const Comment = styled.div`
  background-color: rgba(255, 255, 255, 0.05);
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 15px;
`;

export const CommentAuthor = styled.div`
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 14px;
`;

export const CommentText = styled.p`
  font-size: 14px;
  color: #ccc;
  line-height: 1.5;
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 15px;
  margin-bottom: 30px;
`;

export const PlayButton = styled.button`
  background-color: #0ad519;
  border: none;
  color: white;
  padding: 15px 40px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #0bec1c;
  }
`;

export const AddToListButton = styled.button`
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 15px 30px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
  transition: all 0.3s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.5);
  }
`;

export const ShortVideos = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 15px;
`;

export const ShortVideoCard = styled.div`
  cursor: pointer;
  transition: transform 0.3s ease;
  border-radius: 8px;
  overflow: hidden;
  background-color: rgba(255, 255, 255, 0.05);

  &:hover {
    transform: scale(1.05);
  }
`;

export const ShortVideoThumbnail = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 177.78%; // 9:16 aspect ratio
  background-image: url(${({ src }) => src});
  background-size: cover;
  background-position: center;

  &::after {
    content: '▶';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 40px;
    color: white;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  }
`;

export const ShortVideoInfo = styled.div`
  padding: 10px;
`;

export const ShortVideoTitle = styled.h4`
  font-size: 14px;
  margin-bottom: 5px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ShortVideoDescription = styled.p`
  font-size: 12px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 1);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
`;

export const PopupContent = styled.div`
  width: 100%;
  max-width: 1400px;
  height: 100vh;
  display: flex;
  gap: 20px;
  position: relative;
  padding: 80px 40px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 1);
`;

export const PopupClose = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  background: none;
  border: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
  z-index: 10;
  padding: 5px 15px;
  transition: color 0.3s ease;

  &:hover {
    color: #0ad519;
  }
`;

export const PopupVideoSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 10px;
  }
`;

export const PopupVideoPlayer = styled.div`
  position: relative;
  width: 100%;
  background-color: #000;
  border-radius: 8px;
  overflow: hidden;
`;

export const PopupVideo = styled.video`
  width: 100%;
  height: auto;
  display: block;
  max-height: 80vh;
`;

export const PopupVideoTitle = styled.h2`
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
  padding: 0 20px;
`;

export const PopupShortVideosList = styled.div`
  padding: 0 20px;
`;

export const PopupShortVideoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 15px;
  margin-top: 15px;
`;

export const PopupSidebar = styled.div`
  width: 500px;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 10px;
  }
`;

export const PopupAdCard = styled.div`
  background-color: rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 15px;
  display: flex;
  gap: 15px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.12);
  }
`;

export const PopupAdImage = styled.img`
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 5px;
  flex-shrink: 0;
`;

export const PopupAdInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const PopupAdTitle = styled.h3`
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 5px;
`;

export const PopupAdDescription = styled.p`
  font-size: 12px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const PopupAdLink = styled.a`
  font-size: 11px;
  color: #4a9eff;
  text-decoration: none;
  margin-top: auto;

  &:hover {
    text-decoration: underline;
  }
`;

export const PopupAdQR = styled.img`
  width: 50px;
  height: 50px;
  object-fit: contain;
  margin-left: auto;
  flex-shrink: 0;
`;

export const MainContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 400px;
  gap: 40px;
  align-items: start;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

export const InfoColumn = styled.div`
  /* Info content */
`;

export const PosterColumn = styled.div`
  position: sticky;
  top: 80px;

  @media (max-width: 968px) {
    position: relative;
    top: 0;
  }
`;

export const Poster = styled.img`
  width: 100%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.6);
  object-fit: cover;
`;
